import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommodityType, TableColumn } from '@ui/aos-lib';
import { CommodityUtils } from '@portal/shared/utils/commodity.utils';
import { RouterLink } from '@angular/router';
import { DeviceType } from '../devices.models';
import { MeterTable } from 'src/app/services/data/devices-data/devices-data.types';
import { getUrlPathForDeviceTypeName } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import { devicesWithoutSerialNumber } from '../../constants/devices.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `
    @if (isLinkAvailable()) {
      <a
        [routerLink]="link()"
        [relativeTo]="null"
        >{{ text() }}</a
      >
    }
  `
})
export class SerialNumberColumnComponent {
  item = input.required<MeterTable>();
  column = input.required<TableColumn>();

  private readonly NON_LINKABLE_DEVICE_TYPES: DeviceType[] = devicesWithoutSerialNumber;

  protected readonly isLinkAvailable = computed(() => {
    const deviceType = this.item()['deviceType'] as DeviceType;
    if (this.NON_LINKABLE_DEVICE_TYPES.includes(deviceType)) {
      return false;
    }
    return this.item().deviceUID || this.item().parentDeviceUID;
  });

  protected readonly text = computed(() => {
    const isElectricMeter =
      this.item().deviceType === DeviceType.Meter &&
      CommodityUtils.normalize(this.item().commodity) === CommodityType.Electric;
    return isElectricMeter ? (this.item().serialNumber ?? 'Unknown Serial Number') : this.item().serialNumber;
  });

  protected readonly link = computed(
    () =>
      `devices/${getUrlPathForDeviceTypeName(this.item().deviceType)}/${this.item().deviceUID ?? this.item().parentDeviceUID}`
  );
}
